/**
 * 地図の座標(緯度・軽度)を表すクラス。
 */
const DEFAULT_LATITUDE = 35.681236;
const DEFAULT_LONGITUDE = 139.767125;

export class Coordinate {
  constructor(
    public lat: number = DEFAULT_LATITUDE,
    public lng: number = DEFAULT_LONGITUDE,
  ) {}

  eq(other: Coordinate): boolean {
    return this.lat === other.lat && this.lng === other.lng;
  }

  toObject() {
    return {
      lat: this.lat,
      lng: this.lng,
    };
  }
}
